import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GeminiBatchJobsComponent } from './gemini-batch-jobs.component';

@NgModule({
    declarations: [
        GeminiBatchJobsComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        GeminiBatchJobsComponent
    ]
})
export class GeminiBatchJobsModule { }
